import { ReportTableConfigs } from "@/app/home/components/report/ReportTable";
import { WaterInvoiceModel, WaterInvoiceSummaryModel } from "@/core/models/water-invoice.model";
import { BILLING_REPORT_CONFIGS } from "./billing-report";
import { FilterInputType } from "@/app/home/components/filter/FilterBar";
import { BillingPaymentType, PaymentMethodType, WaterInvoiceStatus } from "@/core/enums/global.enums";
import { paymentMethodPipe } from "@/core/pipes/payment-method-pipe";
import { invoiceStatusPipe } from "@/core/pipes/invoice-status.pipe";
import { billingPaymentTypePipe } from "@/core/pipes/billing-payment-type.pipe";

export const UNIT_TYPE_REPORT_CONFIGS: {name: string, props: ReportTableConfigs<WaterInvoiceModel, WaterInvoiceSummaryModel[]>} = {
    name: "Doanh thu theo đối tượng bảng giá",
    props: {
        ...BILLING_REPORT_CONFIGS.props,
        filterTemplates: [
            {
                dataIndex: "search",
                label: "Tìm kiếm",
                placeholder: "Nhập nội dung tìm kiếm",
                type: FilterInputType.text,
            },
            {
                dataIndex: "month",
                label: "Tháng",
                placeholder: "Chọn tháng",
                type: FilterInputType.month,
            },
            {
                rangeIndex: {from: "DatePaymentFrom", to: "DatePaymentTo"},
                type: FilterInputType.dateRange,
                placeholder: "Thanh toán từ ngày",
                secondaryPlaceholder: "Đến ngày",
                label: "Thời điểm Thanh toán",
                span: 2,
                showTime: true
            },
            {
                dataIndex: "unitTypeId",
                label: "Loại hình",
                placeholder: "Chọn Loại hình",
                type: FilterInputType.select,
                options: []
            },
            {
                dataIndex: "provinceId",
                label: "Tỉnh/ TP",
                placeholder: "Chọn Tỉnh/ TP",
                type: FilterInputType.select,
                options: []
            },
            {
                dataIndex: "districtId",
                label: "Quận/ Huyện",
                placeholder: "Chọn Quận/ Huyện",
                type: FilterInputType.select,
                options: []
            },
            {
                dataIndex: "wardId",
                label: "Xã/ Phường",
                placeholder: "Chọn Xã/ Phường",
                type: FilterInputType.select,
                options: []
            },
            {
                dataIndex: "tollAreaId",
                label: "Khu vực",
                placeholder: "Chọn Khu vực",
                type: FilterInputType.select,
                options: []
            },
            {
                dataIndex: "paymentMethod",
                label: "Hình thức thanh toán",
                placeholder: "Chọn hình thức thanh toán",
                type: FilterInputType.select,
                options: [
                    {value: PaymentMethodType.All, name: paymentMethodPipe(PaymentMethodType.All)},
                    {value: PaymentMethodType.Bank, name: paymentMethodPipe(PaymentMethodType.Bank)},
                    {value: PaymentMethodType.CentralPaid, name: paymentMethodPipe(PaymentMethodType.CentralPaid)},
                    {value: PaymentMethodType.HomePay, name: paymentMethodPipe(PaymentMethodType.HomePay)},
                    {value: PaymentMethodType.EWallet, name: paymentMethodPipe(PaymentMethodType.EWallet)},
                    {value: PaymentMethodType.Manual, name: paymentMethodPipe(PaymentMethodType.Manual)},
                    {value: PaymentMethodType.Transfer, name: paymentMethodPipe(PaymentMethodType.Transfer)},
                ]
            },
            {
                dataIndex: "status",
                label: "Tình trạng thanh toán",
                placeholder: "Chọn tình trạng thanh toán",
                type: FilterInputType.select,
                options: Object.keys(WaterInvoiceStatus).map(key => ({ value: key, name: invoiceStatusPipe(key as WaterInvoiceStatus) }))
            },
            {
                dataIndex: "payBillCreator",
                label: "Người thanh toán",
                placeholder: "Chọn Người thanh toán",
                type: FilterInputType.select,
                options: []
            },
            {
                rangeIndex: {from: "InvoiceTimeFrom", to: "InvoiceTimeTo"},
                type: FilterInputType.dateRange,
                placeholder: "Xuất HĐ từ ngày",
                secondaryPlaceholder: "Đến ngày",
                label: "Thời điểm Xuất HĐĐT",
                span: 2,
                showTime: true
            },
            {
                dataIndex: "paymentType",
                label: "Loại thanh toán",
                placeholder: "Chọn loại thanh toán",
                type: FilterInputType.select,
                options: [
                    { value: BillingPaymentType.Transfer, name: billingPaymentTypePipe(BillingPaymentType.Transfer) },
                    { value: BillingPaymentType.Cash, name: billingPaymentTypePipe(BillingPaymentType.Cash) },
                    { value: BillingPaymentType.Debtminusdeposit, name: billingPaymentTypePipe(BillingPaymentType.Debtminusdeposit) },
                    { value: BillingPaymentType.CollectVNPayQr, name: billingPaymentTypePipe(BillingPaymentType.CollectVNPayQr) },
                    { value: BillingPaymentType.CollectEmployee, name: billingPaymentTypePipe(BillingPaymentType.CollectEmployee) },
                ]
            },
]
    }
}